import { create } from 'zustand';

/** tab */
export type LifecycleManageTab = 'HTTP' | 'COMMAND' | 'TCP_PORT';

export interface LifecycleManageData {
  tab?: LifecycleManageTab;
  // HTTP请求 - 协议
  protocol?: 'HTTP' | 'HTTPS';
  /** 路径 */
  path?: string;
  /** HTTP端口 */
  httpPort?: number;
  // 执行的命令
  command?: string;
  // TCP端口
  tcpPort?: number;
}

interface LifecycleManageState {
  /** 是否勾选了生命周期管理 */
  isLifecycleManageSelected?: boolean;
  /** 启动后动作 */
  postStartAction?: LifecycleManageData;
  /** 终止前动作 */
  preStopAction?: LifecycleManageData;
  /** 共享校验函数 */
  validateLifecycleManage?: () => Promise<boolean>;
}
const initState: LifecycleManageState = {
  isLifecycleManageSelected: false,
  postStartAction: undefined,
  preStopAction: undefined,
};

interface LifecycleManageAction {
  toggleLifecycleManageSelected: (value: boolean) => void;
  /** 更新 */
  updatePostStartAction: (data: LifecycleManageData) => void;
  updatePreStopAction: (data: LifecycleManageData) => void;
  removePostStartAction: () => void;
  removePreStopAction: () => void;
  setValidateLifecycleManage: (validate: () => Promise<boolean>) => void;
  /** 点击编辑 modal 初始化组件数据需要将 */
  reset: () => void;
}

export const useLifecycleManageStore = create<LifecycleManageState & LifecycleManageAction>()(
  (set, get) => ({
    ...initState,
    toggleLifecycleManageSelected: (value: boolean) => set({ isLifecycleManageSelected: value }),
    updatePostStartAction: (data: LifecycleManageData) => set({ postStartAction: data }),
    updatePreStopAction: (data: LifecycleManageData) => set({ preStopAction: data }),
    removePostStartAction: () => set({ postStartAction: undefined }),
    removePreStopAction: () => set({ preStopAction: undefined }),
    setValidateLifecycleManage: (validate: () => Promise<boolean>) =>
      set({ validateLifecycleManage: validate }),
    reset: () => set(initState),
  }),
);
